import React from "react";
import { SidebarProvider } from "@/components/ui/sidebar";
import Teachersidebar from "./Teachersidebar";
import Teacherheader from "./Teacherheader";
import { useSuspensionCheck } from "./useSuspensionCheck";
import { Loader2 } from "lucide-react";
import SuspensionWarning from "./SuspensionWarning";
import SchoolCalendar from "@/components/SchoolCalendar";

const TeacherSchoolCalendar = () => {
  const { isSuspended, isLoading, schoolName: suspendedSchoolName, schoolID, hasValidClaims } = useSuspensionCheck();

  if (isLoading) {
    return (
      <SidebarProvider>
        <div className="flex h-screen w-full bg-gray-50 dark:bg-gray-900">
          <Teachersidebar />
          <div className="flex flex-col flex-1 h-full">
            <Teacherheader />
            <main className="flex-1 overflow-y-auto min-h-0 p-4 md:p-6">
              <div className="flex items-center justify-center h-[60vh]">
                <Loader2 className="h-8 w-8 animate-spin text-primary" />
              </div>
            </main>
          </div>
        </div>
      </SidebarProvider>
    );
  }

  if (isSuspended) {
    return (
      <SidebarProvider>
        <div className="flex h-screen w-full bg-gray-50 dark:bg-gray-900">
          <Teachersidebar />
          <div className="flex flex-col flex-1 h-full">
            <Teacherheader />
            <main className="flex-1 overflow-y-auto min-h-0 p-4 md:p-6">
              <SuspensionWarning schoolName={suspendedSchoolName} />
            </main>
          </div>
        </div>
      </SidebarProvider>
    );
  }

  return (
    <SidebarProvider>
      <div className="flex h-screen w-full bg-gray-50 dark:bg-gray-900">
        <Teachersidebar />
        <div className="flex flex-col flex-1 h-full">
          <Teacherheader />
          <main className="flex-1 overflow-y-auto min-h-0 p-4 md:p-6">
            <SchoolCalendar schoolID={hasValidClaims ? schoolID : null} />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default React.memo(TeacherSchoolCalendar);
